import { get_maia_search_results } from "./maiaPlugin";

// Fallback to Maia Router (OpenAI Compatible)
export async function callMaiaRouter(messages: any[], model: string = "maia/gemini-2.5-flash", jsonMode = false): Promise<string> {
  // Call local API route (proxied in dev, serverless in prod)
  const response = await fetch("/api/chat", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      model: model,
      messages: messages,
      response_format: jsonMode ? { type: "json_object" } : undefined
    })
  });

  if (!response.ok) {
    throw new Error(`Maia Router Error: ${response.statusText}`);
  }

  const data = await response.json();
  return data.choices?.[0]?.message?.content || "";
}

export { get_maia_search_results };
